import React, { Component, Fragment } from 'react';
import { Table, Button, Popup, Icon, Grid } from 'semantic-ui-react';
import SearchTableData from '../../util/SearchTableData';
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

class PropertyTable extends Component {
    render() {
        const {
            allOrganizationalUnitProperties,
            filteredOrganizationalUnitProperties,
            columns,
            activateDetailsRequest,
            writePrivilege,
            isColumnDropdownOpen,
            toggleColumnDropdown,
            excelData,
            getResults,
            handleSearchTextChange,
            deletingRowId,
            saving,
            handleDeleteClick,
            handleConfirmClick,
            handleCancelClick,
        } = this.props;

        return (
            <Table celled selectable sortable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={columns.length + 2}>
                            <Grid stackable verticalAlign="middle">
                                <Grid.Column width={14}>
                                    <SearchTableData
                                        profMozilla
                                        data={allOrganizationalUnitProperties}
                                        getResults={getResults}
                                        filterItem={['_searchProperty', '_searchOrgUnit', '_searchType', '_searchStreet', '_searchPlace', '_searchNotes']}
                                        onSearchTextChange={handleSearchTextChange}
                                    />
                                </Grid.Column>
                                <Grid.Column width={2} textAlign="right">
                                    <ExcelFile filename="Nepokretna imovina" element={<Popup
                                        trigger={<Button animated="vertical" color="green" basic
                                                         floated="right" fluid
                                                         style={{ textAlign: 'center' }}>
                                            <Button.Content hidden><Icon name="download"/></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content="Preuzmi Excel"
                                        hideOnScroll
                                        position="top center"
                                    />}>
                                        <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)} name="Imovina"/>
                                    </ExcelFile>
                                </Grid.Column>
                            </Grid>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                        {columns && columns.map(col => (
                            <Table.HeaderCell key={col.key}>{col.displayName}</Table.HeaderCell>
                        ))}
                        <Table.HeaderCell textAlign="center">
                            <Popup
                                content={isColumnDropdownOpen ? 'Odustani' : 'Uredi kolone'}
                                position="top center"
                                trigger={
                                    <Button
                                        circular
                                        basic
                                        color={isColumnDropdownOpen ? 'red' : 'blue'}
                                        icon={isColumnDropdownOpen ? 'close' : 'setting'}
                                        size="tiny"
                                        onClick={toggleColumnDropdown}
                                    />
                                }
                            />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {filteredOrganizationalUnitProperties.slice()
                        .reverse()
                        .map((el, index) =>
                            (
                                <Table.Row key={index}>
                                    <Table.Cell width={1}>{index + 1}.</Table.Cell>
                                    {columns && columns.map(col => (
                                        <Table.Cell key={col.key}>{col.accessor(el)}</Table.Cell>
                                    ))}
                                    <Table.Cell verticalAlign="middle" className="text-center">
                                        {writePrivilege ?
                                            <Fragment>
                                                {deletingRowId === el.id
                                                    ?
                                                    <Fragment>
                                                        <Popup
                                                            content="Potvrdi"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={handleConfirmClick}
                                                                    disabled={saving}
                                                                    loading={saving}
                                                                >
                                                                    <Icon name="check"/>
                                                                </Button>
                                                            }
                                                        />
                                                        <Popup
                                                            content="Otkaži"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={handleCancelClick}
                                                                    disabled={saving}
                                                                >
                                                                    <Icon name="close"/>
                                                                </Button>
                                                            }
                                                        />
                                                    </Fragment>
                                                    :
                                                    <Fragment>
                                                        <Popup
                                                            content="Detalji"
                                                            position="top center"
                                                            trigger={

                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    icon="align justify"
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={() => {
                                                                        localStorage.setItem('orgUnitProperty', JSON.stringify(el));
                                                                        localStorage.setItem('orgUnitPropertyId', el.id);
                                                                        activateDetailsRequest();
                                                                    }}
                                                                    disabled={deletingRowId}
                                                                />
                                                            }
                                                        />
                                                        <Popup
                                                            content="Brisanje"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    icon="trash alternate"
                                                                    size="tiny"
                                                                    color="red"
                                                                    disabled={deletingRowId && deletingRowId !== el.id}
                                                                    onClick={() => handleDeleteClick(el.id)}
                                                                />
                                                            }
                                                        />
                                                    </Fragment>
                                                }
                                            </Fragment>
                                            :
                                            <Popup
                                                content="Detalji"
                                                position="top center"
                                                trigger={

                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="align justify"
                                                        size="tiny"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.setItem('orgUnitProperty', JSON.stringify(el));
                                                            localStorage.setItem('orgUnitPropertyId', el.id);
                                                            activateDetailsRequest();
                                                        }}
                                                        disabled={deletingRowId}
                                                    />
                                                }
                                            />
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            ))
                    }
                </Table.Body>
            </Table>
        );
    }
}

export default PropertyTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyTable.js